export default {"src":"/_next/static/media/rewarding.b423d3ba.svg","height":125,"width":82};